import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraBadge, SpecraLink } from '@mono/ui-components/ensigns';
import { SpecraPageHeader } from '@mono/ui-components/lieutenants';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { companySizeLabel } from '../../../Delivery/Registries/companySize';
import { registryHref } from '../../registryHref';
import { sbaCertLabels } from './SbaProgramsSection';
import { useCompanySbaProfile } from './sbaClient';
const kinds = {
    COMPETITOR: 'competitor',
    TEAMMATE: 'teammate',
    PRIME_WE_SUB_TO: 'prime we sub to',
    OUR_SUB: 'our sub',
    PART_OF: 'part of',
    OURS: 'ours',
    MENTOR_TO: 'mentor to',
    PROTEGE_OF: 'protégé of'
};
export function companyRelationships(d) {
    return [
        ...d.relationships
    ].sort((a, b)=>Number(!!a.until) - Number(!!b.until)).map((r)=>`${r.until ? 'former ' : ''}${kinds[r.kind] ?? r.kind.toLowerCase().replace(/_/g, ' ')}`).filter((v, i, all)=>all.indexOf(v) === i);
}
export function CompanyHeader({ dossier: d, actions }) {
    const sba = useCompanySbaProfile(d.companyId);
    const certs = sbaCertLabels(sba.data?.certifications ?? []);
    const relationships = companyRelationships(d);
    const size = [
        d.businessSize && d.businessSize !== 'UNKNOWN' ? companySizeLabel(d.businessSize) : '',
        d.samBusinessSize && d.samBusinessSize !== 'UNKNOWN' ? `SAM: ${companySizeLabel(d.samBusinessSize).toLowerCase()}` : ''
    ].filter(Boolean).join(' · ');
    const vehicles = d.vehicleHoldings.length ? d.vehicleHoldings.flatMap((v)=>v.vehicle ? [
            v.vehicle
        ] : []) : d.priceListVehicles;
    const acquired = d.lineage.filter((l)=>l.relationshipType === 'acquisition' && l.direction === 'TO_US');
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                titleSize: "home",
                title: d.name,
                eyebrow: `Company${relationships.length ? ` · ${relationships.slice(0, 2).join(' and ')}` : ''}`,
                description: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        size,
                        vehicles.map((v, i)=>/*#__PURE__*/ _jsxs("span", {
                                children: [
                                    (size || i > 0) && ' · ',
                                    !d.vehicleHoldings.length && 'price list on ',
                                    /*#__PURE__*/ _jsx(SpecraLink, {
                                        href: registryHref(v) ?? undefined,
                                        renderLink: renderRouterLink,
                                        children: v.name
                                    })
                                ]
                            }, v.id)),
                        acquired.map((l)=>/*#__PURE__*/ _jsxs("span", {
                                children: [
                                    ' ',
                                    "· acquired ",
                                    l.other?.name,
                                    l.effectiveStart && ` in ${l.effectiveStart.toDate().getUTCFullYear()}`,
                                    " (history kept under both names)"
                                ]
                            }, l.relationshipId)),
                        certs.length > 0 && ` · ${certs.join(' · ')}`
                    ]
                }),
                actions: actions
            }),
            relationships.length > 0 && /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-2",
                children: relationships.map((r)=>/*#__PURE__*/ _jsx(SpecraBadge, {
                        variant: "neutral",
                        children: r
                    }, r))
            })
        ]
    });
}
